import LazyTabs from './LazyTabs';

export default LazyTabs;
